/**
 * @generated SignedSource<<40d6ef912a0c10b81e4bb6bf5d4de0cd>>
 * @relayHash 7fbd44b7b195b0263a244f68b9781379
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0ff9d3b1123e3ca95975e3b78d63122ba5c367587628b46eb1310db36a26717c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraLongRunningTaskStatus = "CANCELLED" | "CANCEL_REQUESTED" | "COMPLETE" | "DEAD" | "ENQUEUED" | "FAILED" | "RUNNING" | "%future added value";
export type mainEditFormSubmitStatus_progressPollingQuery$variables = {
  cloudId: string;
  taskId: string;
};
export type mainEditFormSubmitStatus_progressPollingQuery$data = {
  readonly jira: {
    readonly bulkOperationProgress: {
      readonly progress: AGG$Long | null | undefined;
      readonly status: JiraLongRunningTaskStatus | null | undefined;
      readonly taskId: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"processResponse_bulkOperationsCommon">;
    } | null | undefined;
  } | null | undefined;
};
export type mainEditFormSubmitStatus_progressPollingQuery = {
  response: mainEditFormSubmitStatus_progressPollingQuery$data;
  variables: mainEditFormSubmitStatus_progressPollingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "taskId",
    "variableName": "taskId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "progress"
},
v3 = {
  "kind": "ScalarField",
  "name": "taskId"
},
v4 = {
  "kind": "ScalarField",
  "name": "status"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mainEditFormSubmitStatus_progressPollingQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueBulkOperationProgress",
            "kind": "LinkedField",
            "name": "bulkOperationProgress",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "processResponse_bulkOperationsCommon"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mainEditFormSubmitStatus_progressPollingQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueBulkOperationProgress",
            "kind": "LinkedField",
            "name": "bulkOperationProgress",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "name": "totalIssueCount"
              },
              {
                "concreteType": "JiraIssueBulkOperationFailureConnection",
                "kind": "LinkedField",
                "name": "failedAccessibleIssues",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueBulkOperationFailureEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueBulkOperationFailure",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "issueId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0ff9d3b1123e3ca95975e3b78d63122ba5c367587628b46eb1310db36a26717c",
    "metadata": {},
    "name": "mainEditFormSubmitStatus_progressPollingQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5fda96b9fc7b0bf909c4b82c92314696";

export default node;
